import React, { useState, useEffect } from 'react'
import { Breadcrumb, Row, Col, Button, Input, Layout, theme, Modal, Space, Table, Drawer, Pagination } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Formik } from 'formik';
import AsyncStorage from '@react-native-async-storage/async-storage';

import {
  CloseOutlined,
  LoadingOutlined,
  CheckOutlined,
} from '@ant-design/icons';
import * as yup from 'yup';

//Dispatchs
import { Creators as MachineTypesActions } from '../../../store/reducers/machine_types';
import { Creators as RefreshActions } from '../../../store/reducers/refresh';

//Styles And Helpers

//Contexts

//Components
import FooterDefault from '../../../components/LayoutDefault/FooterDefault'
import Show from './actions/Show'

//Variables
const filterListSchema = yup.object().shape({

});
const { Content } = Layout;


const MachineTypes = () => {

  //Dispatchs
  const dispatch = useDispatch();

  //States Reducer
  const { dataMachineTypesList, loadingMachineTypesList, dataMachineTypesListUpdate } = useSelector((state) => (state.machine_types))

  //States Local
  const {
    token: { colorBgContainer, colorWarning, colorError, colorInfo },
  } = theme.useToken();

  //---- Open Filter Table
  const [openModalFilter, setOpenModalFilter] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);

  const title = 'Grupos de Máquinas'
  const [openTypeContentDrawer, setOpenTypeContentDrawer] = useState({
    details: {
      status: true,
      title: `Detalhes ${title}`,
      dataShow: {}
    }
  });
  const [filters, setFilters] = useState({
    name: '',
    code: '',
    brand_id: '',
  }
  );

  //Context

  //Cicle of Life
  useEffect(() => {

    document.title = 'Grupo de Máquinas - Iguaçu Máquinas';
    const autoLogin = async () => {
      const refreshToken = await AsyncStorage.getItem('iguacu:refresh');
      dispatch(RefreshActions.getRefreshRequest({ token: refreshToken }));
      return refreshToken
    }
    autoLogin()
  }, []);

  useEffect(() => {
    updateDataList('1')
  }, []);

  useEffect(() => {
    if (dataMachineTypesListUpdate) {
      updateDataList('1')
    }
  }, [dataMachineTypesListUpdate]);

  //Functions
  const updateDataList = (selectedPage) => {
    let payloadList = {
      page: selectedPage,
      name: filters.name,
      code: filters.code,
      brand_id: filters.brand_id,
    }
    // console.log('payloadList', payloadList)
    dispatch(MachineTypesActions.getMachineTypesListRequest(payloadList))
  }

  //---Filter
  const updateFilter = () => {
    updateDataList(1)
    setOpenModalFilter(false)
  }

  const setFieldFilter = (name, value) => {
    setFilters(prevFilters => ({
      ...prevFilters,
      [name]: value
    }))
  }

  const resetFilters = () => {
    setFilters({
      name: '',
      code: '',
      brand_id: ''
    });
    let payloadList = {
      page: '1',
      name: '',
      code: '',
      brand_id: ''
    }
    dispatch(MachineTypesActions.getMachineTypesListRequest(payloadList))
  }

  const showModalFilter = () => {
    setOpenModalFilter(true);
  }
  const hideModalFilter = () => {
    setOpenModalFilter(false);
  }

  //---Drawer Actions Adicionar || Deletar
  const showDrawer = () => {
    setOpenDrawer(true);
  };
  const onCloseDrawer = () => {
    setOpenDrawer(false);
    setOpenTypeContentDrawer({
      details: {
        status: false,
        title: `Detalhes ${title}`,
        dataShow: {}
      }
    })
  };

  const handleChangeTypeContentDrawer = (name, dataShow = {}) => {
    if (name === 'detail') {
      setOpenTypeContentDrawer({
        details: {
          status: true,
          title: `Detalhes ${title}`,
          dataShow: dataShow
        }
      })
    }
    showDrawer()
  }

  const getTitle = () => {
    if (openTypeContentDrawer?.details?.status) {
      return openTypeContentDrawer?.details?.title
    }
  }

  //---Configurations Columns Table
  const columns = [
    {
      title: 'Id',
      dataIndex: 'recno',
      key: 'recno',
      render: (text, record, i) =>
        <div className='row px-2'>
          {record?.recno}
        </div>
      ,
    },
    {
      title: 'Marca',
      dataIndex: 'brand',
      key: 'brand',
      render: (text, record, i) =>
        <div className='row px-2'>
          {record?.brand?.brand}
        </div>
      ,
    },
    {
      title: 'Cód. Grupo Máq.',
      dataIndex: 'code',
      key: 'code',
      render: (text, record, i) =>
        <div className='row px-2'>
          {record?.code}
        </div>
      ,
    },
    {
      title: 'Grupo de Máquinas',
      dataIndex: 'name',
      key: 'name',
      render: (text, record, i) =>
        <div className='row px-2'>
          <b>{record?.name}</b>
        </div>
      ,
    },
    {
      title: 'Ativo',
      dataIndex: 'deleted_at',
      key: 'deleted_at',
      render: (text, record, i) =>
        <div >
          {(record?.deleted_at === null) ?
            <CheckOutlined style={{ fontSize: 18, color: "#52c41a" }} />
            :
            <CloseOutlined style={{ fontSize: 18, color: "#dc3545" }} />
          }
        </div>
      ,
    },
    {
      title: 'Ações',
      dataIndex: 'actions',
      key: 'actions',
      render: (text, record, index) => (
        < Space size="middle" >
          <Button
            size='small' type="primary" style={{ background: colorWarning }}
            onClick={() => handleChangeTypeContentDrawer('detail', record)}
          >
            Detalhes
          </Button>
        </Space >
      ),
    },
  ];

  //Render
  return (
    <>
      <Content>
        <Breadcrumb
          className='breadcrumb px-3 py-2'
          items={[{
            title: 'Máquinas',
          },
          { title: title }]}
        />
        <div
          className='px-4 py-3'
          style={{ background: colorBgContainer }}
        >
          <div className='container'>
            <div className='row justify-content-between'>
              <div className='p-2'>
                <Button
                  size='small'
                  className='m-2'
                  type="primary"
                  style={{ background: colorInfo }}
                  onClick={showModalFilter}
                >
                  Adicionar Filtros
                </Button>
                <Button
                  size='small'
                  className='m-2'
                  onClick={() => {
                    resetFilters()
                  }}
                  style={{ background: colorError }}
                  type='primary'
                >
                  Limpar Filtros
                </Button>
              </div>
              <div className='p-2'>
              </div>
            </div>
          </div>
          <div className='table-content'>
            <Table pagination={false} loading={(loadingMachineTypesList) && { indicator: <LoadingOutlined /> }} rowKey="id" columns={columns} dataSource={dataMachineTypesList?.data} />
          </div>
          {
            dataMachineTypesList?.last_page > 1 &&
            <div className='m-3 text-right'>
              <Pagination
                pageSize={dataMachineTypesList?.per_page}
                showSizeChanger={false}
                showTotal={(total, range) => `${total} itens`}
                onChange={(e) => updateDataList(e)}
                current={dataMachineTypesList?.current_page}
                defaultPageSize={`${dataMachineTypesList?.per_page}`}
                total={dataMachineTypesList?.total}
              />
            </div>
          }
        </div>

        {/* Modal Filters */}
        <Modal title="Filtros"
          open={openModalFilter}
          footer={null}
          onCancel={hideModalFilter}
        >
          <div className='p-2' style={{ backgroundColor: '#f0f2f5' }}>
            <Formik
              initialValues={{
                name: filters?.name,
                code: filters?.code,
                brand_id: filters?.brand_id,
              }}
              validationSchema={filterListSchema}
              onSubmit={() => (
                updateFilter()
              )
              }
            >
              {({ handleSubmit, values, errors, touched }) => (
                <div>
                  <Row gutter={[16, 16]}>
                    <Col span={12}>
                      <label className='p-2' htmlFor="brand_id">Marca</label>
                      <Input
                        className='input-default'
                        value={filters.brand_id}
                        onChange={(e) => setFieldFilter('brand_id', e.target.value)}
                        size="large"
                        placeholder="Marca"
                      />
                    </Col>
                    <Col span={12}>
                      <label className='p-2' htmlFor="code">Cód. Grupo Máq.</label>
                      <Input
                        className='input-default'
                        value={filters.code}
                        onChange={(e) => setFieldFilter('code', e.target.value)}
                        size="large"
                        placeholder="Cód. Grupo Máq."
                      />
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={24}>
                      <label className='p-2' htmlFor="name">Grupo de Máq.</label>
                      <Input
                        className='input-default'
                        value={filters.name}
                        onChange={(e) => setFieldFilter('name', e.target.value)}
                        size="large"
                        placeholder="Grupo de Máq."
                      />
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={24}>
                      <Button
                        size='small'
                        className='m-2'
                        disabled={(loadingMachineTypesList) ? true : false}
                        loading={(loadingMachineTypesList) ? true : false}
                        onClick={() => handleSubmit(values)}
                        type="primary"
                      >
                        Filtrar
                      </Button>
                    </Col>
                  </Row>
                </div>
              )}
            </Formik>
          </div>
        </Modal>

        {/* Modal Actions Show */}
        <Drawer
          title={getTitle()}
          className="drawer-machinetypes-show"
          placement={'right'}
          closable={true}
          onClose={onCloseDrawer}
          open={openDrawer}
          key={'right'}
          closeIcon={<CloseOutlined />}
          width={'50%'}
        >
          <>
            {
              (openTypeContentDrawer?.details.status) &&
              <>
                <Show dataShow={openTypeContentDrawer?.details?.dataShow}></Show>
              </>
            }
          </>
        </Drawer>
        <FooterDefault />
      </Content>
    </>
  );
};

export default MachineTypes;